import script from "./login_forgetPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./login_forgetPassword.vue?vue&type=script&lang=ts&setup=true"

import "./login_forgetPassword.vue?vue&type=style&index=0&id=61ffbd9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ffbd9a"]])

export default __exports__